import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propNumber } from '../../../../../helpers/custom-prop-types';
const SkeletonRow = () => (_jsxs("tr", Object.assign({ className: 'solution_row' }, { children: [_jsx("td", Object.assign({ className: 'solution_col skeleton_col' }, { children: _jsx("div", { className: 'skeleton_block' }) })), _jsx("td", Object.assign({ className: 'solution_col skeleton_col' }, { children: _jsx("div", { className: 'skeleton_block' }) })), _jsx("td", Object.assign({ className: 'solution_col skeleton_col' }, { children: _jsx("div", { className: 'skeleton_block' }) })), _jsx("td", Object.assign({ className: 'solution_col skeleton_col' }, { children: _jsx("div", { className: 'skeleton_block' }) }))] })));
const SkeletonRows = (props) => {
    const { skeletons } = props;
    const rows = useMemo(() => [...Array(skeletons || 3)].map((_, i) => i), [skeletons]);
    return rows.map((v) => _jsx(SkeletonRow, {}, v));
};
SkeletonRows.propTypes = {
    skeletons: propNumber().isRequired,
};
export default SkeletonRows;
